<template>
    <b-card no-body>
        <b-tabs card v-model="tabIdx">
            <b-tab title="Summary" active>
                <b-card-body>
                    <b-form @submit.stop.prevent="onSubmit">
                        <!-- disable input fields when the user can only view and not update  -->
                        <b-form-group
                            id="name-group"
                            label="Name"
                            label-for="input-name"
                            label-cols="3"
                        >
                            <b-form-input
                                type="text"
                                id="input-name"
                                v-model="model.name"
                                required
                                placeholder="Enter Name"
                                trim
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="description-group"
                            label="Description"
                            label-for="input-description"
                            label-cols="3"
                        >
                            <b-form-input
                                type="text"
                                id="input-description"
                                v-model="model.description"
                                required
                                placeholder="Enter description"
                                trim
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="completed-group"
                            label="Completed"
                            label-for="input-completed"
                            label-cols="3"
                        >
                            <b-form-checkbox
                                id="input-completed"
                                v-model="model.completed"
                                :unchecked-value="0"
                                :value="1"
                            ></b-form-checkbox>
                        </b-form-group>

                        <b-form-group
                            id="archived-group"
                            label="Archived"
                            label-for="input-archived"
                            label-cols="3"
                        >
                            <b-form-checkbox
                                id="input-archived"
                                v-model="model.archived"
                                :unchecked-value="0"
                                :value="1"
                            ></b-form-checkbox>
                        </b-form-group>

                        <b-button
                            variant="secondary"
                            :disabled="loading ? true : false"
                            @click="cancel()"
                            >{{ cancelLabel }}</b-button
                        >

                        <!-- render the sumbit button only if the user can create and/or update -->
                        <b-button
                            type="submit"
                            variant="primary"
                            :disabled="loading ? true : false"
                            >{{ submitLabel }}</b-button
                        >
                        <b-button
                            @click="deleteItem()"
                            class="mr-2"
                            variant="warning"
                        >
                            Delete Item
                        </b-button>
                    </b-form>
                </b-card-body>
            </b-tab>
            <b-tab title="Processes">
                <b-card-body>
                    <template-items v-if="tabIdx === 1" :template="template" />
                </b-card-body>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
//name, description, order_type_id, order_category_id
import TemplateItems from './TemplateItems'
export default {
    name: 'ViewItem',
    components: {
        TemplateItems,
    },
    data() {
        return {
            model: {
                id: 0,
                name: null,
                description: null,
                archived: false,
                completed: false,
                items: [],
            },
            loading: false,
            hasErrors: false,
            tabIdx: 0,
        }
    },
    props: ['item'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            return !this.model.id ? true : false
        },
        /**
         * True if the user has permission to view but not update an order template and clicked the view button on a template in the table, otherwise false.
         */
        canView() {
            return this.model.id ? true : false
        },
        /**
         * True if the user has permission to update an order template and clicked the view button on a template in the table, otherwise false.
         */
        canUpdate() {
            return this.model.id ? true : false
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
        cancelLabel() {
            if (this.canView) {
                return 'Back'
            } else {
                return 'Cancel'
            }
        },
        templates() {
            const templates = this.$store.state.checkoffTemplates.templates
            console.log('templates', templates)
            return templates
        },
        template() {
            return this.$store.state.checkoffTemplates.selectedTemplate
        },
    },
    watch: {},
    mounted() {
        // ensure that the selected template and model are cleared for a new template or updated with an existing template
        if (this.item.id) {
            this.model = this.item
            this.$store
                .dispatch('checkoffTemplates/fetchById', this.item.id)
                .then(() => {
                    this.model = this.template
                })
        } else {
            this.$store.dispatch('checkoffTemplates/newTemplate', this.model)
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const path = `checkoffTemplates/${model.id ? 'update' : 'create'}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            this.$emit('success', !!model.id)
                        })
                        .catch(error => {
                            console.log('error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'checkoffTemplates/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Order Template?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Order Template!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted')
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
